import React, {useState} from "react";
import missions from "../missions";
import i18next from "i18next";

const Task = (props) => {
    const [missionIsVisible, setMissionIsVisible] = useState(false);
    const task = props.task;

    const onDisplayMissionClick = e => setMissionIsVisible(!missionIsVisible);

    return (
        !task.started ? <div/> :
            <div className="task-item">
                <div className="task-header">
                            <span
                                className="display-task"
                                style={{marginRight: "5px", backgroundColor: "grey", cursor: "pointer"}}
                                onClick={onDisplayMissionClick}
                            >&#160;{missionIsVisible ? "–" : "+"}&#160;</span>
                    <span className="task-name">{i18next.t(task.name)}</span>
                    <span className="task-status" style={{paddingLeft: "5px"}}>
                                {
                                    task.finished ?
                                        <span style={{color: "blue"}}>Finished</span> :
                                        <span style={{color: "green"}}>In Progress</span>
                                }
                            </span>
                </div>
                <div className="task-body" style={missionIsVisible ? {display: "block"} : {display: "none"}}>
                    <div className="task-desc">{i18next.t(task.description)}</div>
                    <span className="task-conditions" style={{color: "red", paddingLeft: "5px"}}>
                                {task.conditions === "" ? <span/> : <span>({i18next.t(task.conditions)})</span>}
                            </span>
                </div>
            </div>
    );
};

const Mission = (props) => {
    const [missionIsVisible, setMissionIsVisible] = useState(false);
    const mission = props.mission;

    const onDisplayMissionClick = e => setMissionIsVisible(!missionIsVisible);

    return (
        !mission.started ? <div/> :
            <div className="mission-item" style={{backgroundColor: "#E0E0E0", lineHeight: 1.25}}>
                <div style={{minWidth: "300px"}}>
                    <span
                        className="display-mission"
                        style={{marginRight: "10px", backgroundColor: "grey", cursor: "pointer"}}
                        onClick={onDisplayMissionClick}
                    >&#160;{missionIsVisible ? "–" : "+"}&#160;</span>
                    <span className="mission-name" style={{fontWeight: "bold"}}>{i18next.t(mission.name)}</span>
                    <span className="mission-status" style={{paddingLeft: "5px"}}>
                        {mission.finished ?
                            <span style={{color: "blue"}}>Finished</span> :
                            <span style={{color: "green"}}>In Progress</span> }
                    </span>
                </div>
                <div style={missionIsVisible ? {display: "block"} : {display: "none"}}>
                    <div className="mission-desc">{i18next.t(mission.description)} </div>
                    <div className="mission-tasks">{
                        !mission.tasks ? i18next.t("other.missions.noTasks") :
                            Object.keys(mission.tasks).map((taskName, tKey) => (
                                <Task key={tKey} task={mission.tasks[taskName]}/>
                            ))
                    }</div>
                </div>
            </div>
    );
};

const Missions = (props) => {

    const missionsAreStarted = () => {
        for (const [name, mission] of Object.entries(missions)) {
            if (mission.started)
                return true;
        }
        return false;
    };

    return (
        <div className="missions">
            <h3>Missions:</h3>
            <div className="missions-body">
                {!missionsAreStarted() ? <div>Missions are not started yet.</div> :
                    Object.keys(missions).map((missionName, key) => (
                        <Mission mission={missions[missionName]} key={key}/>
                    ))}
            </div>
        </div>
    );
};

export default Missions;